import React from "react";
import { LottieLoader } from "./LottieLoader";
import animationData from "./spinner.json";

export const Spinner = (loaderProps) => (
  <LottieLoader animationData={animationData} {...loaderProps} />
);
